import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import settingsImage from '../../images/tag/settings.svg';
import * as actionTypes from '../../actions/actionTypes';
import downloadTagsCsv from '../../actions/api/tag/downloadTagsCsv';
import {
  Main,
  Contents,
  ContentsTitle,
  SettingsImageWrapper,
  Settings,
  SettingsItem,
  ButtonImage,
} from './styles/MasterTitleStyles';

/**
 * タグセット管理画面のタイトルコンポーネント
 *
 * @param {Object} props - MasterTitleのprops
 * @param {boolean} props.isCompanyAdminUser - 現在のログインユーザーが企業管理者かどうかの真偽値
 */
const MasterTitle = ({ isCompanyAdminUser }) => {
  const dispatch = useDispatch();
  const [showMasterSettings, setShowMasterSetting] = useState(false);
  const { showUnavailableTags, apiToken } = useSelector(state => ({
    showUnavailableTags: state.master.showUnavailableTags,
    apiToken: state.main.apiToken,
  }));

  const handleToggleMasterSettings = () => {
    setShowMasterSetting(!showMasterSettings);
  };

  const handleToggleUnavailableTags = () => {
    dispatch({
      type: showUnavailableTags
        ? actionTypes.HIDE_UNAVAILABLE_TAGS
        : actionTypes.SHOW_UNAVAILABLE_TAGS,
    });
    setShowMasterSetting(false);
  };

  const handleCsvDownload = () => {
    dispatch(downloadTagsCsv(apiToken));
  };

  const handleOpenMasterImportDialog = () => {
    dispatch({ type: actionTypes.OPEN_MASTER_IMPORT_DIALOG });
    setShowMasterSetting(false);
  };

  return (
    <Main className="masterTitle">
      <Contents>
        <ContentsTitle>
          <FormattedMessage id="master.title" />
        </ContentsTitle>
        <SettingsImageWrapper
          isShow={showMasterSettings}
          onClick={handleToggleMasterSettings}
        >
          <ButtonImage
            id="settingButton"
            role="presentation"
            src={settingsImage}
            alt="addButton"
            className="button"
          />
        </SettingsImageWrapper>
      </Contents>
      {showMasterSettings && (
        <Settings>
          <SettingsItem
            className="button"
            isEnabled
            onClick={handleToggleUnavailableTags}
          >
            {(showUnavailableTags && (
              <FormattedMessage id="master.settings.item.unavailableTag.hide" />
            )) || (
              <FormattedMessage id="master.settings.item.unavailableTag.show" />
            )}
          </SettingsItem>
          {isCompanyAdminUser && (
            <>
              <SettingsItem
                className="button"
                isEnabled
                onClick={handleCsvDownload}
              >
                <FormattedMessage id="master.settings.item.csvDownload" />
              </SettingsItem>
              <SettingsItem
                className="button"
                isEnabled
                onClick={handleOpenMasterImportDialog}
              >
                <FormattedMessage id="master.settings.item.csv.export" />
              </SettingsItem>
            </>
          )}
        </Settings>
      )}
    </Main>
  );
};

MasterTitle.propTypes = {
  isCompanyAdminUser: PropTypes.bool.isRequired,
};

export default MasterTitle;
